import * as FluxUtils from 'flux/utils';

import { AppDispatcher, DispatcherBaseAction } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { GlobalHelper } from '../utils/GlobalHelper';

import core = egr.wcf.core;

export enum ExtraPopup {
    MENU = 1,
    CAMERA = 2,
    FLOORPLAN = 3
}

export interface ToolsStoreState {
    multiSelect: boolean;
    rectangleSelect: boolean;
    sendImage: string | null;
    camera: core.view.CameraMode | null;
    smartPopup: ExtraPopup | null;
    showWallButton: boolean;
}

class ToolsStoreClass extends FluxUtils.ReduceStore<ToolsStoreState, unknown> {
    public getInitialState(): ToolsStoreState {
        return {
            multiSelect: false,
            rectangleSelect: false,
            sendImage: null,
            camera: null,
            smartPopup: null,
            showWallButton: false
        };
    }

    public reduce(state: ToolsStoreState, action: DispatcherBaseAction): ToolsStoreState {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed
        switch (action.actionType) {
            case ActionConstants.SET_LOADED_PROJECT:
                if (GlobalHelper.coreApp.viewer.activeView) {
                    return jQuery.extend({}, state, {
                        camera: GlobalHelper.coreApp.viewer.activeView.cameraControl.cameraMode
                    });
                }
                break;
            case ActionConstants.SHOW_SMART_EXTRA:
                return jQuery.extend({}, state, {smartPopup: action.value});
            case ActionConstants.SET_CAMERA:
                return jQuery.extend({}, state, {
                    camera: action.value,
                    smartPopup: null
                });
            case ActionConstants.SEND_IMAGE:
                return jQuery.extend({}, state, {sendImage: action.value});
            case ActionConstants.SET_RECTANGLESELECT:
                return jQuery.extend({}, state, {rectangleSelect: action.value});
            case ActionConstants.SET_MULTISELECT:
                return jQuery.extend({}, state, {multiSelect: action.value});
            case ActionConstants.SET_WALLTOOL_FLAG:
                return jQuery.extend({}, state, {showWallButton: action.value});
            case ActionConstants.CHANGE_SIDEBAR:
                return jQuery.extend({}, state, {showWallButton: false});
            default:
                break;
        }
        return state;
    }
}

export let ToolsStore: ToolsStoreClass = new ToolsStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/ToolsStore.ts